module.exports = __webpack_public_path__ + "img/5.81630552.png";